import React from 'react';

const ReactVersion = () => React.version;
export default ReactVersion;
